export default "__VITE_ASSET__DBshzs_t__"